var map = {
	"./ar.json": "./node_modules/vee-validate/dist/locale/ar.json",
	"./az.json": "./node_modules/vee-validate/dist/locale/az.json",
	"./bd.json": "./node_modules/vee-validate/dist/locale/bd.json",
	"./bg.json": "./node_modules/vee-validate/dist/locale/bg.json",
	"./ca.json": "./node_modules/vee-validate/dist/locale/ca.json",
	"./ckb.json": "./node_modules/vee-validate/dist/locale/ckb.json",
	"./cs.json": "./node_modules/vee-validate/dist/locale/cs.json",
	"./da.json": "./node_modules/vee-validate/dist/locale/da.json",
	"./de.json": "./node_modules/vee-validate/dist/locale/de.json",
	"./el.json": "./node_modules/vee-validate/dist/locale/el.json",
	"./en.json": "./node_modules/vee-validate/dist/locale/en.json",
	"./es.json": "./node_modules/vee-validate/dist/locale/es.json",
	"./et.json": "./node_modules/vee-validate/dist/locale/et.json",
	"./eu.json": "./node_modules/vee-validate/dist/locale/eu.json",
	"./fa.json": "./node_modules/vee-validate/dist/locale/fa.json",
	"./fi.json": "./node_modules/vee-validate/dist/locale/fi.json",
	"./fr.json": "./node_modules/vee-validate/dist/locale/fr.json",
	"./he.json": "./node_modules/vee-validate/dist/locale/he.json",
	"./hr.json": "./node_modules/vee-validate/dist/locale/hr.json",
	"./hu.json": "./node_modules/vee-validate/dist/locale/hu.json",
	"./id.json": "./node_modules/vee-validate/dist/locale/id.json",
	"./it.json": "./node_modules/vee-validate/dist/locale/it.json",
	"./ja.json": "./node_modules/vee-validate/dist/locale/ja.json",
	"./ka.json": "./node_modules/vee-validate/dist/locale/ka.json",
	"./ko.json": "./node_modules/vee-validate/dist/locale/ko.json",
	"./lt.json": "./node_modules/vee-validate/dist/locale/lt.json",
	"./lv.json": "./node_modules/vee-validate/dist/locale/lv.json",
	"./mn.json": "./node_modules/vee-validate/dist/locale/mn.json",
	"./ms_MY.json": "./node_modules/vee-validate/dist/locale/ms_MY.json",
	"./nb_NO.json": "./node_modules/vee-validate/dist/locale/nb_NO.json",
	"./ne.json": "./node_modules/vee-validate/dist/locale/ne.json",
	"./nl.json": "./node_modules/vee-validate/dist/locale/nl.json",
	"./nn_NO.json": "./node_modules/vee-validate/dist/locale/nn_NO.json",
	"./pl.json": "./node_modules/vee-validate/dist/locale/pl.json",
	"./pt_BR.json": "./node_modules/vee-validate/dist/locale/pt_BR.json",
	"./pt_PT.json": "./node_modules/vee-validate/dist/locale/pt_PT.json",
	"./ro.json": "./node_modules/vee-validate/dist/locale/ro.json",
	"./ru.json": "./node_modules/vee-validate/dist/locale/ru.json",
	"./sk.json": "./node_modules/vee-validate/dist/locale/sk.json",
	"./sl.json": "./node_modules/vee-validate/dist/locale/sl.json",
	"./sq.json": "./node_modules/vee-validate/dist/locale/sq.json",
	"./sr.json": "./node_modules/vee-validate/dist/locale/sr.json",
	"./sr_Latin.json": "./node_modules/vee-validate/dist/locale/sr_Latin.json",
	"./sv.json": "./node_modules/vee-validate/dist/locale/sv.json",
	"./th.json": "./node_modules/vee-validate/dist/locale/th.json",
	"./tr.json": "./node_modules/vee-validate/dist/locale/tr.json",
	"./uk.json": "./node_modules/vee-validate/dist/locale/uk.json",
	"./vi.json": "./node_modules/vee-validate/dist/locale/vi.json",
	"./zh_CN.json": "./node_modules/vee-validate/dist/locale/zh_CN.json",
	"./zh_TW.json": "./node_modules/vee-validate/dist/locale/zh_TW.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/vee-validate/dist/locale sync recursive ^\\.\\/.*\\.json$";